import Component from './Component';

export default class HeaderSearch extends Component {
  load() {
    this.initHeaderSearch();

    super.load();
  }

  initHeaderSearch() {
    $('[data-toggle="header-search"]').on('click', (e) => {
      const $target = $($(e.currentTarget).data('target'));
      const action = $(e.currentTarget).data('action');

      //
      if ($target.data('status') !== action) {
        e.preventDefault();
        $target.data('status', action);
        $target.toggleClass('header-search__container--active');

        if (action === 'open') {
          const tray = document.querySelector('.header-search__tray');
          const duration = parseFloat(window.getComputedStyle(tray).transitionDuration) * 1000;

          setTimeout(() => $target.find('[type="text"]').focus(), duration);
        } else {
          const overlayPredictive = document.getElementById('header-search-predictive-search');
          if(!overlayPredictive.classList.contains('fade'))
            console.log('4');
            overlayPredictive.classList.add('fade');
        }
      }
    });
  }
}
